import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Il materiale è digitale o fisico?',
    a: "Il Mega-Pack è completamente digitale. Potrai scaricarlo subito dopo l'acquisto e utilizzarlo su computer, tablet o smartphone."
  }, {
    q: 'Come ricevo il materiale?',
    a: "Dopo l'acquisto riceverai l'accesso immediato per scaricare tutti i libri e i bonus direttamente sul tuo dispositivo."
  }, {
    q: 'Per quanto tempo avrò accesso?',
    a: "L'accesso è permanente. Potrai utilizzare il materiale quando vuoi, per sempre."
  }, {
    q: 'Posso utilizzare il materiale per diversi livelli scolastici?',
    a: "Sì, il materiale è progettato per essere adattabile a diversi livelli scolastici e fasce d'età."
  }, {
    q: 'Come funziona la garanzia?',
    a: 'Hai 7 giorni di tempo per testare i materiali. Se non sei soddisfatto, puoi richiedere il rimborso completo senza domande.'
  }, {
    q: 'Posso pagare con carta di credito?',
    a: 'Sì, accettiamo tutte le principali carte di credito, debito e PayPal. Il pagamento è sicuro e crittografato.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        <div className="text-center mb-12" data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-87">
            Domande Frequenti
          </h2>
        </div>

        <div className="space-y-4" data-id="element-88">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-blue-500 shadow-md' : 'border-gray-200'}`} data-id="element-89">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between bg-white hover:bg-gray-50 focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-90">
                <span className="font-bold text-gray-900 pr-8" data-id="element-91">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180 text-blue-500' : ''}`} data-id="element-92" />
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-93">
                <p className="text-gray-600 leading-relaxed" data-id="element-94">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}